import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { AuthService } from '../state/auth/auth.service';
import { ToastService } from '../state/toast/toast.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);

  return from(authService.getTokens()).pipe(
    switchMap((tokens) => {
      // S3 bucket will fail if we add Bearer token, so we skip those requests
      if (req.url.includes(environment.portal.guidanceBucket)) {
        return next(req);
      }
      // Portal calls use access token instead of id token
      if (req.url.includes(environment.portal.osm) || req.url.includes(environment.portal.guidance)) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${tokens.accessToken}` },
        });
        return next(authReq);
      }

      // All other calls use id token
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${tokens.idToken}` },
      });
      return next(authReq);
    }),
    catchError((error) => {
      if (error.status === 401) {
        toastService.showToast({
          type: 'error',
          message: $localize`Authentication failed, please retry.`,
          duration: 0,
        });
      }
      return throwError(() => error);
    }),
  );
};
